<template>
  <div class="index">
    <img src="./img/top.png" alt="" />
    <div class="top">
      <div class="text">公司介绍</div>
      <div class="content">
        <div class="left">
          <img src="./img/hezuo.png" alt="" />
        </div>
        <div class="words">
          杭州图景网络技术有限公司，成立时间2009年4月22日，是一家掌握国内领先GIS技术（地理空间信息技术）的国家级高新技术企业。公司团队独立研发的二三维一体化GIS平台，是基于行业领先的地理信息、数字应用、定位技术，将互联网集成于一体的核心系统。
        </div>
      </div>
    </div>
    <div class="map">
      <img src="./img/map.png" alt="" />
      <div class="info">
        <div class="add">
          <span class="add_top">杭州市西湖区教工路18号</span>
          <span class="add_bottom">EAC欧美中心A座C区805、807、809</span>
        </div>
        <div class="bottom">0571-88223392</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {}
};
</script>

<style scoped lang="scss">
@import url('~@/icons/pingfang/font.css');
.index {
  position: relative;
  img {
    width: 100%;
  }
  .top {
    width: 1920px;
    height: 710px;
    background: #ffffff;
    .text {
      margin-top: 67px;
      margin-left: 849px;
      font-size: 44px;
      font-family: 'PingFang';
      font-weight: 600;
      color: #333333;
    }
    .content {
      display: flex;
      height: 434px;
      padding: 85px 390px 0 360px;
      .left {
        img {
          width: 658px;
          height: 434px;
        }
      }
      .words {
        margin-top: 45px;
        margin-left: 54px;
        background: #ffffff;
        font-size: 20px;
        font-family: 'PingFang';
        font-weight: 400;
        line-height: 40px;
      }
    }
  }
  .map {
    position: relative;
    height: 560px;
    img {
      width: 100%;
      height: 100%;
    }
    .info {
      position: absolute;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 550px;
      height: 250px;
      top: 150px;
      right: 0;
      font-size: 40px;
      color: #fff;
      border-radius: 80px;
      background-color: rgba(102, 115, 150, 0.8);
      .add {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        .add_bottom {
          font-size: px2rem(25rem);
          margin-top: px2rem(20rem);
          text-align: center;
        }
      }
      .bottom {
        font-size: px2rem(25rem);
      }
    }
  }
}
</style>
